
import { Component, Inject, Vue } from 'vue-property-decorator';
import ContentPageRepository from '@/repositories/content/ContentPageRepository';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class ContentPageListScreen extends Vue {
    @Inject()
    private readonly contentPageRepository!: ContentPageRepository;

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.contentPageTranslation.title'),
                align: 'left',
                value: 'defaultTitle',
                sortable: true,
            },
            {
                text: this.$t('crud.contentPage.labelId'),
                value: 'defaultLabelText',
                sortable: true,
            },
            {
                text: this.$t('crud.contentPage.pinned'),
                value: 'pinned',
                sortable: true,
            },
        ];
    }
}
